export default "__VITE_ASSET__D3v$7gnx__"